import { render, staticRenderFns } from "./WaterControlPage.vue?vue&type=template&id=0e30b7b7"
import script from "./WaterControlPage.vue?vue&type=script&lang=js"
export * from "./WaterControlPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports